import { render, staticRenderFns } from "./TableFormItem.vue?vue&type=template&id=055653db&scoped=true&"
import script from "./TableFormItem.vue?vue&type=script&lang=js&"
export * from "./TableFormItem.vue?vue&type=script&lang=js&"
import style0 from "./TableFormItem.vue?vue&type=style&index=0&id=055653db&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055653db",
  null
  
)

export default component.exports